import none from '../../img/leoLogo.png'

export const  appetizer=[
    {
      "id": "31",
      "title": "سیب ساده",
      "desciption": "",
      "price": "145",
      "image": none
    },
    {
      "id": "32",
      "title": "نان سیر",
      "desciption": "",
      "price": "230",
      "image": none
    },
    {
      "id": "33",
      "title": "سیب با سس قارچ",
      "desciption": "",
      "price": "275",
      "image": none
    },
    {
      "id": "34",
      "title": "چیز فرایز",
      "desciption": "",
      "price": "255",
      "image": none
    },
    {
      "id": "35",
      "title": "سالاد سزار",
      "desciption": "",
      "price": "369",
      "image": none
    },
    {
      "id": "36",
      "title": "فیله گریل",
      "desciption": "",
      "price": "290",
      "image": none
    },
    {
      "id": "37",
      "title": "تست مخلوط",
      "desciption": "",
      "price": "130",
      "image": none
    },
    {
      "id": "38",
      "title": "هات چیپس",
      "desciption": "",
      "price": "269",
      "image": none
    },
    {
      "id": "39",
      "title": "fish salad | سالاد ماهی",
      "desciption": "",
      "price": "445",
      "image": none
    }
  ]